import React, {useEffect, useState} from 'react';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzText,
    BringzzInput,
    BringzzButton, BringzzBottomDrawer,
    BringzzRadioList,
    BringzzRadio,
    BringzzImage, BringzzCheckbox, BringzzDate, Mode
} from '@bringzz/components';
import {useNavigation} from 'context/NavigationContext';
import {useLocation} from 'react-router-dom';
import {useAuth} from 'context/AuthContext';
import {
    useDebounce
} from "@bringzz/hooks";
import classNames from 'classnames';
import usePageState from 'hooks/usePageState';
import {compressImageToBase64, formatDateToDDMMYYYY, isValidURL, parseToMySQLDateTime} from 'utils';
import useRequest from "../../../hooks/useRequest";
import {getDataForSubmit} from "../PostHelper";
import { useTranslation } from 'react-i18next';
import DefaultProductImage from 'assets/DefaultProductImage.png';

let state = {
    checked: <div></div>,
    unChecked: <div></div>
};

const EditPostPage = () => {
        const { t } = useTranslation('posts');
        const {backPress} = useNavigation();
        const [addPhotoDrawer, setAddPhotoDrawer] = useState(false);
        const {navigate} = useNavigation();
        const {sendRequest, loading} = useRequest();

        // ???
        const [hasCustomValidity, setHasCustomValidity] = useState(false);
        const [isChecked2, setChecked2] = useState(false);

        // All
        const [ogImage, setOgImage] = useState(null);
        const [fetchingImage, setFetchingImage] = useState(false)
        const [headline, setHeadline] = useState(null)
        const [description, setDescription] = useState(null)
        //const [isConvertingInProgress, setIsConvertingInProgress] = useState(false)

        // External Link Post
        const [externalLink, setExternalLink] = useState('')
        const [validExternalLink, setValidExternalLink] = useState(false)

        // Article Post
        const [blocks, setBlocks] = useState([])
        const [addBlockDrawer, setAddBlockDrawer] = useState(false);

        const [leadIn, setLeadIn] = useState(null);
        const [imageCaption, setImageCaption] = useState(null);
        const [tags, setTags] = useState(null);

        // Product Post
        const [searchQuery, setSearchQuery] = useState('');
        const [filteredProducts, setFilteredProducts] = useState([]);
        const [productDrawer, setAddProductDrawer] = useState(false);
        const [selectedProducts, setSelectedProducts] = useState([]); // State for multiple selected products
        const [viewingProduct, setViewingProduct] = useState(null); // State for the product currently being viewed
        const [release, setRelease] = useState(formatDateToDDMMYYYY(new Date()))
        const [validUntil, setValidUntil] = useState(formatDateToDDMMYYYY(new Date()))

        const [loadingProducts, setLoadingProducts] = useState(false);
        const [allProducts, setAllProducts] = useState([]);

        const debouncedInputValue = useDebounce(externalLink, 500);
        const debouncedSearchQuery = useDebounce(searchQuery, 500);

        const populateForm = (formData) => {
            setValidExternalLink(true)
            setHeadline(formData.headline || '')
            setOgImage(formData.images ? (formData.images[0].content || '') : '')
            setDescription(formData.description || '')
            setExternalLink(formData.link || formData.externalLink || '')

            // Article Post
            setBlocks(formData.components || [])
            setLeadIn(formData.leadIn || null)
            setImageCaption(formData.imageCaption || null)
            setTags(formData.tags || null)

            // Product Post
            if(formData.products){
                updateDiscount(formData.products)
            }
            //setSelectedProducts(formData.products || [])
        }

        const updateDiscount = (products) => {
            let selectedProductsNew = []

            // products.map((product) => {
            //     if(product.discountValue !== null && product.discountValue > 0){
            //         selectedProductsNew.push(product)
            //     } else {
            //         selectedProductsNew.push({...product, discount: false})
            //     }
            // })
            setSelectedProducts(products)
        }

        const formData = usePageState();

        useEffect(() => {
            if (formData) {
                populateForm(formData)
            }

        }, [formData]);

        const fetchProducts = async (query = '', pharmacyId = null) => {
            if (!query.trim()) {
                setFilteredProducts([]);
                return;
            }
            
            setLoadingProducts(true);
            
            try {
                const response = await sendRequest({
                    method: 'POST',
                    url: '/module/product/searchProducts',
                    data: {
                        query: query || null,
                        pharmacyId: pharmacyId,
                        sortBy: 'name_asc',
                        limit: 50,
                        page: 1
                    }
                });

                if (response?.status === 'success' && response?.data) {
                    setFilteredProducts(response.data);
                } else {
                    setFilteredProducts([]);
                }
            } catch (error) {
                console.error('Error fetching products:', error);
                setFilteredProducts([]);
            } finally {
                setLoadingProducts(false);
            }
        };

        useEffect(() => {
            if (debouncedSearchQuery.trim()) {
                fetchProducts(debouncedSearchQuery);
            } else {
                setFilteredProducts([]);
            }
        }, [debouncedSearchQuery]);

        const fetchOpenGraphImage = async (url) => {
            try {
                setFetchingImage(true);
                const response = await fetch(url);
                const html = await response.text();

                // Improved regex to handle various cases, including single quotes and optional attributes.
                const ogImageMatch = html.match(/<meta[^>]*property=["']?og:image["']?[^>]*content=["']([^"']+)["'][^>]*>/i) ||
                    html.match(/<meta[^>]*content=["']([^"']+)["'][^>]*property=["']?og:image["']?[^>]*>/i);

                let imageUrl = null;

                if (ogImageMatch && ogImageMatch[1]) {
                    imageUrl = ogImageMatch[1];
                } else {
                    // Attempt to use a fallback by parsing the entire document for images
                    const fallbackImageMatch = html.match(/<img[^>]*src=["']([^"']+)["'][^>]*>/i);
                    if (fallbackImageMatch && fallbackImageMatch[1]) {
                        imageUrl = fallbackImageMatch[1];
                    }
                }

                if (imageUrl) {
                    // Verify if the image URL is valid and can be loaded
                    const validImage = await validateImage(imageUrl);
                    if (validImage) {
                        setOgImage(imageUrl);
                    }
                }
                console.log("Fetch finished");
                setFetchingImage(false);
            } catch (error) {
                console.error("Error fetching Open Graph data:", error);
                setOgImage(null);
                setFetchingImage(false);
            }
        };

        const validateImage = (url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = url;
                img.onload = () => resolve(true);  // Image successfully loaded
                img.onerror = () => resolve(false);  // Error loading image
            });
        };

        const handlePickerClick = async choice => {
            try {
                let base64Image = '';

                if (choice === 'camera') {
                    // Handling camera input
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: true
                    });
                    const video = document.createElement('video');
                    video.srcObject = stream;
                    video.play();

                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    video.onloadedmetadata = () => {
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        context.drawImage(video, 0, 0, canvas.width, canvas.height);
                        base64Image = canvas.toDataURL('image/jpeg');
                        // Stop the video stream
                        stream.getTracks().forEach(track => track.stop());
                        setOgImage(base64Image);
                        console.log(base64Image);
                    };
                } else if (choice === 'photos') {
                    // Handling gallery input
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.onchange = async event => {
                        const file = event.target.files[0];
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            base64Image = reader.result;
                            setOgImage(base64Image);
                            console.log(base64Image);
                        };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                }
            } catch (error) {
                console.error('Error handling picker choice:', error);
            }
        };

        const handleRemovePhoto = () => {
            setOgImage(null); // Only reset the photo state
        };

        useEffect(() => {
            if (debouncedInputValue.trim() !== '') {
                const fetchData = async () => {
                    await fetchOpenGraphImage(debouncedInputValue)
                };
                fetchData();
            }
        }, [debouncedInputValue]);

        const handleLinkChange = async (e, valid, value) => {
            setValidExternalLink(valid)
            if (valid)
                setExternalLink(value)
        };

        const getDataByType = async (base64Image = null) => {
            switch (formData.type) {
                case 1: // Article
                    if (formData.id) {
                        return {
                            type: formData.type,
                            headline,
                            description,
                            leadIn,
                            ogImage,
                            imageCaption,
                            tags,
                            blocks: formData.components
                        }
                    }
                    return {
                        type: formData.type,
                        headline,
                        description,
                        leadIn,
                        ogImage,
                        imageCaption,
                        tags
                    }
                case 2: // External Link
                    if (isValidURL(ogImage)) {
                        await compressImageToBase64(ogImage)
                            .then(base64Image => {
                                return {
                                    id: formData.id,
                                    ogImage: base64Image,
                                    type: formData.type,
                                    headline,
                                    description,
                                    externalLink
                                }
                            })
                            .catch(error => {
                                console.error(error);
                                alert(t('editPost.errors.imageError'))
                            });
                    } else {
                        return {
                            id: formData.id,
                            type: formData.type,
                            ogImage,
                            headline,
                            description,
                            externalLink
                        }
                    }
                    return {}
                case 3: // Product
                    return {
                        "type": formData.type,
                        "headline": headline,
                        "ogImage": ogImage,
                        "images": [
                            {
                                "content": ogImage
                            }
                        ],
                        "description": description,
                        "release": release,
                        "validity": hasCustomValidity,
                        "products": selectedProducts,
                        "likesHidden": isChecked2,
                        "commentsHidden": isChecked2,
                    }
            }
        }

        const getPostTypeString = () => {
            switch (formData.type) {
                case 1:
                    return t('editPost.postTypes.article')
                case 2:
                    return t('editPost.postTypes.externalLink')
                case 3:
                    return t('editPost.postTypes.product')
                default:
                    return t('editPost.postTypes.post')
            }
        }

        // Article Type -> to block
        // save -> release = null + request + message screen
        // share -> release = null + navigate to share screen
        /**
         * Goes next to the Preview Page or for the Article Post to the Block creation
         * @returns {Promise<void>}
         */
        const onSubmit = async () => {
            // create or update
            //data
            try {
                // Wait for the data to be resolved before navigation
                let submitData = {}
                if (formData.id) { // update
                    submitData = {...await getDataByType(), id: formData.id}
                } else { // create
                    submitData = await getDataByType() // Added await here
                }

                // Now submitData contains the resolved data, not a Promise
                if (formData.id || formData.type === 2 || formData.type === 3) {
                    console.log('PREVIEW')
                    navigate('/posts/preview', {
                        state: submitData
                    })
                } else {
                    navigate('/posts/build/article', {
                        state: submitData
                    })
                }

            } catch (error) {
                console.error('Error preparing data:', error)
                alert(t('editPost.errors.dataPreparation'))
            }
        }

        // only for create
        const savePost = async () => {
            try {
                // Wait for the data to be resolved before navigation
                const submitData = await getDataForSubmit(await getDataByType()) // Added await here

                await sendRequest({
                    method: 'POST',
                    url: '/module/post/createPost',
                    data: submitData
                }).then((response) => {
                    console.log('status', response)
                    if (response.status === 'success') {
                        console.log('SUCCESS')
                        navigate(`/posts/saved/result`)
                    }

                }).catch((error) => {
                    console.log(error);
                })

            } catch (error) {
                console.error('Error preparing data:', error)
                alert(t('editPost.errors.dataPreparation'))
            }
        }

        // Article Post
        const moveBlock = (index, direction) => {
            const updatedBlocks = [...blocks];
            const targetIndex = index + direction;

            if (targetIndex < 0 || targetIndex >= blocks.length) return; // Prevent out-of-bounds moves

            const temp = updatedBlocks[targetIndex];
            updatedBlocks[targetIndex] = updatedBlocks[index];
            updatedBlocks[index] = temp;

            setBlocks(updatedBlocks);
        };

        // Article Post
        const removeBlock = (index) => {
            const updatedBlocks = blocks.filter((_, i) => i !== index);
            setBlocks(updatedBlocks);
        };

        const updateBlockContent = (index, newContent) => {
            const updatedBlocks = [...blocks];
            updatedBlocks[index].content = newContent;
            setBlocks(updatedBlocks);
        };

        //Product Post
        const handleProductSelect = product => {
            const transformedProduct = {
                id: product.id,
                productId: product.id,
                productName: product.name,
                productImage: product.productImage,
                companyname: product.brandName || product.manufacturer,
                type: product.type || 'Medicine',
                productAmount: product.amount || '1',
                packagingType: product.packagingType || 'piece',
                dosage: product.dosage || '',
                price: product.price,
                // discount: false,
                // discountValue: 0,
                // discountType: 'EUR'
            };
            setViewingProduct(transformedProduct);
        };

        const handleCancelSelection = () => {
            setViewingProduct(null);
            setAddProductDrawer(false);
        };

        const handleApplyProduct = () => {
            if (viewingProduct) {
                const isAlreadySelected = selectedProducts.some(p => p.productId === viewingProduct.productId);
                if (!isAlreadySelected) {
                    setSelectedProducts([...selectedProducts, viewingProduct]);
                }
            }
            setViewingProduct(null);
            setAddProductDrawer(false);
        };

        const handleRemoveProduct = (productId) => {
            let newSelectedProducts = []
            selectedProducts.map((product) => {
                if (product.productId === productId) {
                    if (product.id) { // have to be deleted at the database
                        newSelectedProducts = [...newSelectedProducts, {...product, deleted: 1}]
                    }
                } else {
                    newSelectedProducts = [...newSelectedProducts, product]
                }
            })
            setSelectedProducts(newSelectedProducts)
        };

        const handleAddDiscount = (productId) => {
            const updatedProducts = selectedProducts.map(product =>
                product.productId === productId
                    ? {...product, discount: true}
                    : product
            );

            setSelectedProducts(updatedProducts);
        }

        const handleRemoveDiscount = (productId) => {
            const updatedProducts = selectedProducts.map(product =>
                product.productId === productId
                    ? {...product, discount: false, discountValue: 0}
                    : product
            );

            setSelectedProducts(updatedProducts);
        }

        const handleDiscountSelection = (productId, type) => { // EUR, %
            let updatedProducts = []

            selectedProducts.map(product =>
                product.productId === productId
                    ? updatedProducts = [...updatedProducts, {...product, discountType: type}]
                    : updatedProducts = [...updatedProducts, product]
            );
            console.log('handle discount', updatedProducts)
            setSelectedProducts(updatedProducts);
        }

        const handleDiscountValue = (productId, value) => {
           console.log('VALUE', value)
            /*const updatedProducts = selectedProducts.map(product =>
                product.id === productId
                    ? {...product, discountValue: value}
                    : product
            );*/

            let newSelectedProducts = []
            selectedProducts.map((product) => {
                if (product.productId === productId) {
                        newSelectedProducts = [...newSelectedProducts, {...product, discountValue: value}]
                } else {
                    newSelectedProducts = [...newSelectedProducts, product]
                }
            })

            setSelectedProducts(newSelectedProducts);
        }

        const isValidPost = () => {
            switch (formData.type) {
                case 1:
                    return (!ogImage || !headline || !description || !leadIn || !imageCaption || !tags) // Article
                case 2:
                    return (!ogImage || !validExternalLink || !headline || !description || !externalLink) // External Link
                case 3:
                    return (!ogImage || !headline || !description || selectedProducts.length === 0) // Product
            }
        }

    console.log('Discount' , selectedProducts[0] ? (selectedProducts[0].discount) : '')

        // All the same: headline, images, description, release, imagecaption
        // Only PRODUCT POST: products
        // Only ARTICLE POST: components, tags
        // Only EXTERNAL LINK: link
        return (
            (
                <BringzzPageContainer
                    header={{
                        left: (
                            <BringzzIcon
                                size="22"
                                icon="IconChevronLeft"
                                folder="LineIcons"
                                className="cursor-pointer"
                                onClick={backPress}
                            />
                        ),
                        title: <BringzzText tag="h2">{formData.id ? t('editPost.title.update') : t('editPost.title.create')} {getPostTypeString()}</BringzzText>
                    }}
                    footer={
                        <div className="pt-4 pb-28 px-6 flex flex-row space-x-4">
                            {(formData.id || formData.type !== 1) && <BringzzButton
                                size="md"
                                disabled={formData.id ? false : isValidPost()}
                                onClick={formData.id ? backPress : savePost}
                                className="border w-full border-black justify-center"
                            >
                                {(formData.id ? t('editPost.buttons.cancel') : t('editPost.buttons.save'))}
                            </BringzzButton>}
                            <BringzzButton
                                onClick={onSubmit}
                                size="md"
                                disabled={isValidPost()}
                                className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                            >
                                {formData.type === 1 ? t('editPost.buttons.continue') : (formData.id ? t('editPost.buttons.update') : t('editPost.buttons.create'))}
                            </BringzzButton>
                        </div>
                    }
                >
                    <div className="p-4">
                        <BringzzInput
                            label={t('editPost.labels.headline')}
                            tooltip="something"
                            placeholder={t('editPost.placeholders.headline')}
                            defaultValue={headline}
                            required={true}
                            onChange={(e, valid, value) => {
                                if (valid)
                                    setHeadline(value)
                            }}
                        />

                        {formData.type === 1 &&
                            <BringzzInput
                                label={t('editPost.labels.articleLeadIn')}
                                type="textarea"
                                placeholder=""
                                tooltip="something"
                                defaultRows={5}
                                defaultValue={leadIn}
                                required={true}
                                onChange={(e, valid, value) => {
                                    if (valid)
                                        setLeadIn(value)
                                }}
                            />
                        }

                        <div className="space-y-4">
                            {formData.type === 2 &&
                                <BringzzInput
                                    label={t('editPost.labels.externalLink')}
                                    tooltip="something"
                                    placeholder={t('editPost.placeholders.externalLink')}
                                    pattern='^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$'
                                    onChange={handleLinkChange}
                                    defaultValue={externalLink}
                                    icon={{
                                        right: <div style={{animation: 'spin 4s linear infinite'}} className='text-black'>
                                            {fetchingImage &&
                                                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 2V6M12 18V22M6 12H2M22 12H18M19.0784 19.0784L16.25 16.25M19.0784 4.99994L16.25 7.82837M4.92157 19.0784L7.75 16.25M4.92157 4.99994L7.75 7.82837"
                                                        stroke="black" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round"/>
                                                </svg>}
                                        </div>
                                    }}
                                />
                            }

                            <div
                                className={
                                    classNames(
                                        `w-full my-4 rounded-md flex flex-col items-center justify-center bg-white transition-all duration-300 space-y-4`,)
                                }
                            >
                                {
                                    ogImage && <div className="relative w-full h-full border rounded-md">
                                        <img src={ogImage} alt={"Couldn't load image"}
                                             className="h-48 w-full object-cover rounded-md"/>
                                        <BringzzIcon
                                            size="24"
                                            icon="IconTrashCan"
                                            folder="LineIcons"
                                            className="absolute text-white top-2 right-2 cursor-pointer"
                                            onClick={handleRemovePhoto}
                                        />
                                    </div>
                                }
                            </div>

                            <div
                                className="flex cursor-pointer border rounded-md items-center justify-between w-full p-3"
                                onClick={() => setAddPhotoDrawer(true)}
                            >
                                <div className='flex items-center space-x-2'>
                                    <BringzzIcon
                                        size="24"
                                        icon="IconImage"
                                        folder="LineIcons"
                                        className="cursor-pointer text-gray-500"
                                    />
                                    <BringzzText tag="h4" className="text-gray-500">{t('editPost.labels.customImage')}</BringzzText>
                                </div>
                            </div>
                            <BringzzInput
                                label={t('editPost.labels.description')}
                                type="textarea"
                                placeholder={t('editPost.placeholders.description')}
                                tooltip="something"
                                defaultValue={description}
                                defaultRows={5}
                                required={true}
                                onChange={(e, valid, value) => {
                                    if (valid)
                                        setDescription(value)
                                }}
                            />

                            {/* Article */}
                            {formData.type === 1 &&
                                <div className='space-y-4 mt-4'>
                                    <BringzzInput
                                        label={t('editPost.labels.mainImageCaption')}
                                        tooltip="something"
                                        placeholder={t('editPost.placeholders.imageCaption')}
                                        defaultValue={imageCaption}
                                        required={true}
                                        onChange={(e, valid, value) => {
                                            if (valid)
                                                setImageCaption(value)
                                        }}
                                    />
                                    <BringzzInput
                                        label={t('editPost.labels.tags')}
                                        tooltip="something"
                                        placeholder={t('editPost.placeholders.tags')}
                                        defaultValue={tags}
                                        required={true}
                                        onChange={(e, valid, value) => {
                                            if (valid)
                                                setTags(value)
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    {/* Article - Blocks */}
                    {
                        formData.type === 1 &&
                        <div className="mt-4 space-y-4">
                            {blocks.map((block, index) => (
                                <div key={block.id} className='border border-gray-300 rounded-md'>
                                    <div className='flex justify-between items-center p-3 border-b'>
                                        <div><BringzzText className={'font-normal'}
                                                          tag='h3'>{block.component === 'inline_heading' ? t('editPost.blocks.inlineHeading') : t('editPost.blocks.bodyCopy')}</BringzzText>
                                        </div>
                                        <div className='flex items-center'>
                                            <BringzzIcon folder='LineIcons' icon='IconChevronDown' size='22'
                                                         className='pr-1 cursor-pointer'
                                                         onClick={() => moveBlock(index, 1)} // Move block down
                                            />
                                            <BringzzIcon folder='LineIcons' icon='IconChevronUp' size='22'
                                                         className='pr-2 cursor-pointer'
                                                         onClick={() => moveBlock(index, -1)} // Move block up
                                            />
                                            <BringzzIcon folder='LineIcons' icon='IconTrashCan' size='24'
                                                         className='border-l pl-1 cursor-pointer'
                                                         onClick={() => removeBlock(index)} // Remove block
                                            />
                                        </div>
                                    </div>
                                    <div key={index} className="p-2">
                                        {block.component === 'inline_heading' ? (
                                            <BringzzInput
                                                value={block.content}
                                                onChange={(e) => updateBlockContent(index, e.target.value)}
                                                placeholder={t('editPost.placeholders.headingContent')}
                                            />
                                        ) : (
                                            <BringzzInput
                                                value={block.content}
                                                type='textarea'
                                                defaultRows={5}
                                                onChange={(e) => updateBlockContent(index, e.target.value)}
                                                className="w-full border rounded-md p-2"
                                                placeholder={t('editPost.placeholders.bodyContent')}
                                            />
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {/* Product Post - Products */}
                    {formData.type === 3 &&
                        <div className="flex flex-col space-y-4 mt-4 px-4">
                            <div className="w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-1">{t('editPost.labels.products')}</label>
                                {selectedProducts && selectedProducts.map(product => (
                                    <div key={product.id}>
                                        {!product.deleted &&
                                            <div className='border border-gray-300 rounded-md mb-2'>
                                                <div
                                                    className="relative w-full flex items-center justify-between bg-white p-3">
                                                    <div className="flex items-center">
                                                        <img 
                                                            src={product.productImage || DefaultProductImage} 
                                                            className="w-12 h-12 bg-gray-100 rounded-md mr-4 object-cover"
                                                            alt={product.productName}
                                                            onError={(e) => {
                                                                if (e.target.src !== DefaultProductImage) {
                                                                    e.target.src = DefaultProductImage;
                                                                    e.target.className = e.target.className.replace('object-cover', 'object-contain p-2');
                                                                }
                                                            }}
                                                        />
                                                        <div>
                                                            <BringzzText tag="h3"
                                                                         className="font-semibold">{product.productName}</BringzzText>
                                                            <BringzzText tag="h5" className="text-gray-500">
                                                                {product.companyname} | {product.type || 'unknown'} | {product.productAmount} {product.packagingType} | {product.dosage}
                                                            </BringzzText>
                                                            {/* {!product.discount && <BringzzText
                                                                tag="h4"
                                                                className="text-magic-lilac block mt-1 cursor-pointer"
                                                                onClick={() => handleAddDiscount(product.productId)}
                                                            >Add Discount</BringzzText>} */}
                                                        </div>
                                                    </div>
                                                    <BringzzIcon
                                                        size="24"
                                                        icon="IconTrashCan"
                                                        folder="LineIcons"
                                                        className="cursor-pointer text-gray-500"
                                                        onClick={() => handleRemoveProduct(product.productId)}
                                                    />

                                                </div>
                                                {(product.discount) && (
                                                    <div
                                                        className='flex justify-around items-center bg-slate-200 py-2 px-3'>
                                                        <div></div>
                                                        <div
                                                            className='flex items-stretch h-full border border-gray-300 rounded-md'>
                                                            <div className="flex-1 flex h-full">
                                                                <BringzzInput
                                                                    className='bg-transparent text-center h-8 border-none rounded-none rounded-l-md'
                                                                    placeholder='00.00'
                                                                    type="number"
                                                                    value={product.discountValue}
                                                                    onChange={(e) => {
                                                                        handleDiscountValue(product.productId, e.target.value)
                                                                    }}
                                                                />

                                                            </div>
                                                            <div
                                                                className={classNames(
                                                                    'flex-1 cursor-pointer flex justify-center items-center h-8 border-l border-l-gray-300',
                                                                    product.discountType === "EUR" && "bg-magic-lilac"
                                                                )}
                                                                onClick={() => handleDiscountSelection(product.productId, "EUR")}
                                                            >
                                                                <BringzzText tag='h4'>EUR</BringzzText>
                                                            </div>
                                                            <div
                                                                className={classNames(
                                                                    'flex-1 cursor-pointer flex justify-center items-center h-8 border-l border-l-gray-300',
                                                                    product.discountType === "%" && "bg-magic-lilac rounded-r-md"
                                                                )}
                                                                onClick={() => handleDiscountSelection(product.productId, "%")}
                                                            >
                                                                <BringzzText tag='h4'>%</BringzzText>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <BringzzIcon
                                                                size="24"
                                                                icon="IconCirclePlus"
                                                                folder="LineIcons"
                                                                className="cursor-pointer text-gray-500 rotate-45"
                                                                onClick={() => handleRemoveDiscount(product.productId)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                                }
                                            </div>}
                                    </div>
                                ))}
                                <div
                                    className="relative w-full h-12 border border-gray-300 rounded-md flex items-center justify-center bg-white cursor-pointer"
                                    onClick={() => setAddProductDrawer(true)}
                                >
                                    <div className="flex items-center justify-between w-full px-3">
                                        <BringzzText tag="h4" className="text-gray-500">{t('editPost.buttons.addProduct')}</BringzzText>
                                        <BringzzIcon
                                            size="24"
                                            icon="IconCirclePlus"
                                            folder="LineIcons"
                                            className="cursor-pointer text-gray-500"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* Product Post - Checkboxen */}
                    {
                        formData.type === 3 &&
                        <div className="space-y-2 pl-1 mt-4 px-4">
                            <BringzzCheckbox
                                id="example-checkbox1"
                                label={t('editPost.labels.customPostValidity')}
                                checked={hasCustomValidity}
                                onChange={setHasCustomValidity}
                            />
                            {hasCustomValidity &&
                                <div className='flex space-x-2'>
                                    <div>
                                        <BringzzText tag='h4' className='font-normal'>{t('editPost.labels.validFrom')}</BringzzText>
                                        <BringzzDate
                                            placeholder={release}
                                            defaultValue={new Date()}
                                            format="dd/MM/yyyy"
                                            onChange={(newDate) => setRelease(newDate)}
                                            mode={Mode.DAY}
                                            minDate={new Date()}
                                        ></BringzzDate>
                                    </div>
                                    <div>
                                        <BringzzText tag='h4' className='font-normal'>{t('editPost.labels.validUntil')}</BringzzText>
                                        <BringzzDate
                                            placeholder={validUntil}
                                            format="dd/MM/yyyy"
                                            onChange={(newDate) => setValidUntil(newDate)}
                                            mode={Mode.DAY}
                                            minDate={new Date()}
                                        ></BringzzDate>
                                    </div>
                                </div>}
                            <BringzzCheckbox
                                id="example-checkbox2"
                                label={t('editPost.labels.hideLikesComments')}
                                checked={isChecked2}
                                onChange={setChecked2}
                            />
                        </div>
                    }
                    {/* Article - Select content Block */}
                    {
                        formData.type === 1 &&
                        <BringzzBottomDrawer
                            isOpen={addBlockDrawer}
                            title={t('editPost.blocks.selectContentBlock')}
                            close={() => setAddBlockDrawer(false)}
                        >
                            <div className="px-4 py-6">
                                <BringzzRadioList
                                    state={state}
                                    className="rounded-xl w-full text-center"
                                    onChange={choice => {
                                        handlePickerClick(choice);
                                        setAddBlockDrawer(false);
                                    }}
                                >
                                    <BringzzRadio
                                        value="inline_heading"
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex"
                                    >
                                        <div>{t('editPost.blocks.inlineHeading')}</div>
                                    </BringzzRadio>
                                    <BringzzRadio
                                        value="body_copy"
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{t('editPost.blocks.bodyCopy')}</div>
                                    </BringzzRadio>
                                </BringzzRadioList>
                            </div>
                        </BringzzBottomDrawer>
                    }
                    {
                        formData.type === 3 &&
                        <BringzzBottomDrawer
                            isOpen={productDrawer}
                            title={viewingProduct ? t('editPost.product.productDetails') : t('editPost.product.findProduct')}
                            close={() => setAddProductDrawer(false)}
                        >
                            <div className="px-4 py-6">
                                {viewingProduct ? (
                                    <div className="space-y-4">
                                        <div className="flex items-center border border-gray-300 rounded-md p-3 space-x-4">
                                            <img 
                                                src={viewingProduct.productImage || DefaultProductImage} 
                                                className="w-16 h-16 bg-gray-100 rounded-md object-cover"
                                                alt={viewingProduct.productName}
                                                onError={(e) => {
                                                    if (e.target.src !== DefaultProductImage) {
                                                        e.target.src = DefaultProductImage;
                                                        e.target.className = e.target.className.replace('object-cover', 'object-contain p-2');
                                                    }
                                                }}
                                            />
                                            <div>
                                                <BringzzText tag="h3" className="font-semibold">
                                                    {viewingProduct.productName}
                                                </BringzzText>
                                                <BringzzText tag="h5" className="text-gray-500">
                                                    {viewingProduct.companyname}
                                                </BringzzText>
                                                <BringzzText tag="p" className="text-sm font-semibold text-magic-lilac">
                                                    €{parseFloat(viewingProduct.price || 0).toFixed(2)}
                                                </BringzzText>
                                            </div>
                                        </div>
                                        {/* 
                                        <div className="flex justify-center py-2 items-center space-x-4">
                                            <div
                                                className="flex w-full border border-gray-300 p-3 space-y-1 rounded-md flex-col items-center">
                                                <div className="w-12 h-12 bg-gray-100 rounded-full"></div>
                                                <BringzzText tag="h4">{viewingProduct.type || 'unknown'}</BringzzText>
                                                <BringzzText tag="h5" className="text-blue-500">Change</BringzzText>
                                            </div>
                                            <div
                                                className="flex w-full border border-gray-300 p-3 space-y-1 rounded-md flex-col items-center">
                                                <div className="w-12 h-12 bg-gray-100 rounded-full"></div>
                                                <BringzzText tag="h4">???</BringzzText>
                                                <BringzzText tag="h5" className="text-blue-500">Change</BringzzText>
                                            </div>
                                            <div
                                                className="flex w-full border border-gray-300 p-3 space-y-1 rounded-md flex-col items-center">
                                                <div className="w-12 h-12 bg-gray-100 rounded-full"></div>
                                                <BringzzText
                                                    tag="h4">{viewingProduct.productAmount} {viewingProduct.packagingType}</BringzzText>
                                                <BringzzText tag="h5" className="text-blue-500">Change</BringzzText>
                                            </div>
                                        </div>
                                        */}
                                        <div className="flex justify-around space-x-4">
                                            <BringzzButton
                                                size="md"
                                                className="border w-full border-black justify-center"
                                                onClick={handleCancelSelection}
                                            >
                                                {t('editPost.buttons.cancel')}
                                            </BringzzButton>
                                            <BringzzButton
                                                size="md"
                                                className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                                                onClick={handleApplyProduct}
                                            >
                                                {t('editPost.buttons.apply')}
                                            </BringzzButton>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="mb-4">
                                            <BringzzInput
                                                icon={{
                                                    left: (
                                                        <BringzzIcon
                                                            icon="IconSearchAlt"
                                                            folder="LineIcons"
                                                            className="h-6 w-6"
                                                            size="24"
                                                        />
                                                    )
                                                }}
                                                placeholder={t('editPost.product.searchProducts')}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>
                                        
                                        {loadingProducts && (
                                            <div className="flex justify-center py-8">
                                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-magic-lilac"></div>
                                            </div>
                                        )}
                                        
                                        {!loadingProducts && searchQuery.trim() && filteredProducts.length === 0 && (
                                            <div className="text-center py-8 text-gray-500">
                                                <BringzzText tag="p">{t('editPost.product.noProductsFound')}</BringzzText>
                                            </div>
                                        )}
                                        
                                        {!loadingProducts && !searchQuery.trim() && (
                                            <div className="text-center py-8 text-gray-500">
                                                <BringzzIcon
                                                    icon="IconSearch"
                                                    folder="LineIcons"
                                                    size="48"
                                                    className="mx-auto mb-4 text-gray-300"
                                                />
                                                <BringzzText tag="p">{t('editPost.product.startTyping')}</BringzzText>
                                            </div>
                                        )}
                                        
                                        <div className="space-y-2 max-h-96 overflow-y-auto">
                                            {!loadingProducts && filteredProducts.map((product, index) => (
                                                <div
                                                    key={product.id || index}
                                                    className="flex items-center p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
                                                    onClick={() => handleProductSelect(product)}
                                                >
                                                    <img 
                                                        src={product.productImage || DefaultProductImage} 
                                                        className="h-12 w-12 mr-3 rounded bg-gray-100 object-cover"
                                                        alt={product.name}
                                                        onError={(e) => {
                                                            if (e.target.src !== DefaultProductImage) {
                                                                e.target.src = DefaultProductImage;
                                                                e.target.className = e.target.className.replace('object-cover', 'object-contain p-2');
                                                            }
                                                        }}
                                                    />
                                                    <div className="flex-1">
                                                        <BringzzText tag="h4" className="font-semibold">
                                                            {product.name}
                                                        </BringzzText>
                                                        <BringzzText tag="p" className="text-sm text-gray-600">
                                                            {product.brandName} • PZN: {product.pzn}
                                                        </BringzzText>
                                                        <BringzzText tag="p" className="text-sm font-semibold text-magic-lilac">
                                                            €{parseFloat(product.price || 0).toFixed(2)}
                                                        </BringzzText>
                                                    </div>
                                                    <BringzzIcon
                                                        size="16"
                                                        icon="IconChevronRight"
                                                        folder="LineIcons"
                                                        className="text-gray-400"
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </BringzzBottomDrawer>
                    }
                    <BringzzBottomDrawer
                        isOpen={addPhotoDrawer}
                        title={t('editPost.photo.uploadTitle')}
                        close={() => setAddPhotoDrawer(false)}
                    >
                        <div className="px-4 py-6">
                            <BringzzRadioList
                                state={state}
                                className="rounded-xl w-full text-center"
                                onChange={choice => {
                                    handlePickerClick(choice);
                                    setAddPhotoDrawer(false);
                                }}
                            >
                                <BringzzRadio
                                    value="camera"
                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex"
                                >
                                    <div>{t('editPost.photo.camera')}</div>
                                </BringzzRadio>
                                <BringzzRadio
                                    value="photos"
                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                >
                                    <div>{t('editPost.photo.photos')}</div>
                                </BringzzRadio>
                            </BringzzRadioList>
                        </div>
                    </BringzzBottomDrawer>
                </BringzzPageContainer>
            )
        )
            ;
    }
;

export default EditPostPage;
